import React from 'react';
import { Award, Clock, Handshake } from 'lucide-react';
export function ValueSection() {
  return <section id="values" className="py-20 md:py-32 bg-[#1a4d5c] text-white relative overflow-hidden" data-id="element-171">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#2d5f6d] rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-172"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#d4a017] rounded-full blur-3xl opacity-10 translate-y-1/2 -translate-x-1/2" data-id="element-173"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-174">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-175">
          <div data-id="element-176">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-177">
              Why Choose <span className="text-[#d4a017]" data-id="element-178">Manifold Trade</span>
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-179">
              Our diversified approach to trading is supported by sector
              expertise, market knowledge, and established relationships across
              energy and automotive industries.
            </p>

            <div className="space-y-8" data-id="element-180">
              <div className="flex gap-4" data-id="element-181">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#2d5f6d] flex items-center justify-center text-[#d4a017]" data-id="element-182">
                  <Award size={24} data-id="element-183" />
                </div>
                <div data-id="element-184">
                  <h3 className="text-xl font-bold mb-2" data-id="element-185">
                    Multi-Sector Expertise
                  </h3>
                  <p className="text-gray-300" data-id="element-186">
                    Deep understanding across energy, automotive, and mobility
                    sectors with established trading networks.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-187">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#2d5f6d] flex items-center justify-center text-[#d4a017]" data-id="element-188">
                  <Handshake size={24} data-id="element-189" />
                </div>
                <div data-id="element-190">
                  <h3 className="text-xl font-bold mb-2" data-id="element-191">
                    Trusted Partnerships
                  </h3>
                  <p className="text-gray-300" data-id="element-192">
                    Building long-term relationships with suppliers and buyers
                    across traditional and emerging markets.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-193">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#2d5f6d] flex items-center justify-center text-[#d4a017]" data-id="element-194">
                  <Clock size={24} data-id="element-195" />
                </div>
                <div data-id="element-196">
                  <h3 className="text-xl font-bold mb-2" data-id="element-197">
                    Professional Standards
                  </h3>
                  <p className="text-gray-300" data-id="element-198">
                    Commitment to industry best practices and regulatory
                    compliance across all trading activities.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative h-full min-h-[400px] rounded-lg overflow-hidden border-4 border-[#2d5f6d]" data-id="element-199">
            <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1611&q=80" alt="Maritime operations" className="absolute inset-0 w-full h-full object-cover" data-id="element-200" />
            <div className="absolute inset-0 bg-[#1a4d5c]/40" data-id="element-201"></div>
          </div>
        </div>
      </div>
    </section>;
}